import { fetchUserAccount } from '@/api/user'
import { updateSubscription, deleteSubscription } from '@/api/order'
import { fetchDataBuckets } from '@/api/mvno'
import { objectHasKeys } from '@/utils/comparators'

const reset = ({ commit }) => {
  commit('RESET_STATE')
}

const fetchUserProducts = async ({ commit }) => {
  let response = await fetchUserAccount()
  commit('SET_BUCKETS', response)
}

const loadUserProducts = async ({ dispatch, state }) => {
  if (!objectHasKeys(state.buckets)) {
    await dispatch('fetchUserProducts')
  }
}

const fetchUserDataBuckets = async ({ commit }) => {
  return new Promise((resolve, reject) => {
    try {
      let response = fetchDataBuckets()
      commit('SET_DATA_BUCKETS', response)
      resolve()
    } catch (ex) {
      commit('SET_DATA_BUCKETS', false)
      reject(ex)
    }
  })
}

const loadUserDataBuckets = async ({ dispatch, state }) => {
  if (!state.dataBuckets) {
    await dispatch('fetchUserDataBuckets')
  }
}

const activateSubscription = async ({ dispatch, state }, pid) => {
  try {
    await updateSubscription(pid)
    await dispatch('fetchUserProducts')
  } catch (error) {
    throw error
  }
}

const deactivateSubscription = async ({ dispatch, state }, pid) => {
  try {
    await deleteSubscription(pid)
    await dispatch('fetchUserProducts')
  } catch (error) {
    throw error
  }
}

export default {
  fetchUserProducts,
  loadUserProducts,
  fetchUserDataBuckets,
  loadUserDataBuckets,
  activateSubscription,
  deactivateSubscription,
  reset
}



// WEBPACK FOOTER //
// ./src/store/modules/user/products/actions.js